/**
 * Fairway Mortgage (CW-4606) — treatment names are the next free onN per split
 * based on treatments present in code. Confirm against Harness before go-live
 * and update here if Harness uses different names.
 *
 * Harness ops checklist (dashboard — not in repo):
 * For movoto-cpc-apply-cw-9238, movoto-cpc-preapproved-cw-9240,
 * movoto-cpc-lender-cw-9242, movoto-calcpayment-cw-12068:
 * 1. Create Fairway treatment matching FAIRWAY_TREATMENT below
 * 2. Expose attrs: movoto_geo_zipcode, movoto_listing_price,
 *    movoto_listing_status, movoto_listing_type
 * 3. Targeting rule from ticket CBSA_Zip_Codes.csv: zip in list,
 *    price >= 100000, status active, type not MOBILE/LAND
 * 4. Traffic under that rule:
 *    - 9238 / 12068: 5% Fairway, 90% on3, 5% on14
 *    - 9240 / 9242: 5% Fairway, 90% on4, 5% on14
 * 5. Keep movoto_cw_frontend flag set for client-side flags
 * 6. Target go-live ~2026-08-13
 */
export const FAIRWAY_TREATMENT = {
    'movoto-cpc-apply-cw-9238': 'on17',
    'movoto-cpc-preapproved-cw-9240': 'on18',
    'movoto-cpc-lender-cw-9242': 'on17',
    'movoto-calcpayment-cw-12068': 'on18',
};

function safeDecode(value) {
    if (value == null || value === '') {
        return '';
    }
    try {
        return decodeURIComponent(String(value));
    } catch (e) {
        return String(value);
    }
}

/**
 * Build Fairway partner URL with ticket UTM params.
 * @param {{ cta?: string, price?: string|number, state?: string, zipcode?: string, propertyType?: string, listingUrl?: string, address?: string }} sendOpt
 * @returns {string}
 */
export function buildFairwayRedirectUrl(sendOpt = {}) {
    const params = new URLSearchParams({
        utm_campaign: 'movoto',
        utm_term: String(sendOpt.cta || '').trim(),
        utm_purchasePrice: String(sendOpt.price ?? ''),
        utm_state: safeDecode(sendOpt.state),
        utm_zip: String(sendOpt.zipcode || ''),
        utm_propertyType: String(sendOpt.propertyType || ''),
        utm_propertyUrl: safeDecode(sendOpt.listingUrl),
        utm_propertyAddress: safeDecode(sendOpt.address),
    });
    return `https://www.fairway.com/movoto?${params.toString()}`;
}
